import type { SessionContext, SimpleBillingAccessState, UserRole } from "../api/types";
import { simpleBillingRoute } from "./simpleBillingRoutes";

export const SIMPLE_BILLING_FEATURE = "SIMPLE_BILLING";

export function hasFeature(session: Pick<SessionContext, "features">, featureCode: string): boolean {
  return Array.isArray(session.features) && session.features.includes(featureCode);
}

export function hasSimpleBillingAccess(
  session: Pick<SessionContext, "features" | "featureTenantId" | "simpleBillingAccess" | "user">,
): boolean {
  if (simpleBillingAccessState(session) === "locked") return false;
  return session.user.role !== "super_admin" || Boolean(session.featureTenantId);
}

export function simpleBillingAccessState(
  session: Pick<SessionContext, "features" | "simpleBillingAccess">,
): SimpleBillingAccessState {
  if (session.simpleBillingAccess) return session.simpleBillingAccess.state;
  return hasFeature(session, SIMPLE_BILLING_FEATURE) ? "full" : "locked";
}

export function canWriteSimpleBilling(
  session: Pick<SessionContext, "features" | "simpleBillingAccess">,
): boolean {
  return ["full", "grace"].includes(simpleBillingAccessState(session));
}

export function pathAllowsReadOnlySimpleBilling(pathname: string): boolean {
  const normalized = pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;
  if (normalized === "/simple-billing" || normalized === "/simple-billing/invoices" || normalized === "/simple-billing/estimates" || normalized === "/simple-billing/pending-payments" || normalized === "/simple-billing/collections" || normalized === "/simple-billing/expenses" || normalized === "/simple-billing/business-summary" || normalized === "/simple-billing/reports") {
    return true;
  }
  return /^\/simple-billing\/invoices\/[^/]+$/.test(normalized);
}

export function roleCanAccessSimpleBillingPath(role: UserRole, pathname: string): boolean {
  const normalized = pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;
  if (normalized === "/simple-billing") return true;
  return simpleBillingRoute(normalized)?.roles.includes(role) || false;
}
